var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Title',{attrs:{"title":_vm.$t('codeC.title'),"description":_vm.$t('codeC.description')}}),_c('GitHubRepoStream',{attrs:{"gitHubUserName":"UnterrainerInformatik","language":"c#"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }